import { gql } from '@apollo/client';
import { ORDER_TABLE_PROFILE_FIELDS } from '@/graphql/fragments/order_table_profiles';

export const INSERT_ORDER_TABLE_PROFILE = gql`
    ${ORDER_TABLE_PROFILE_FIELDS}
    mutation InsertOrderTableProfile($object: order_table_profiles_insert_input = {}) {
        insert_order_table_profiles_one(object: $object) {
            ...OrderTableProfileFields
        }
    }
`;

export const UPDATE_ORDER_TABLE_PROFILE_BY_PK = gql`
    ${ORDER_TABLE_PROFILE_FIELDS}
    mutation UpdateOrderTableProfileByPk($order_table_profile_id: uuid!, $set: order_table_profiles_set_input = {}) {
        update_order_table_profiles_by_pk(pk_columns: { order_table_profile_id: $order_table_profile_id }, _set: $set) {
            ...OrderTableProfileFields
        }
    }
`;

export const DELETE_ORDER_TABLE_PROFILE_BY_PK = gql`
    mutation DeleteOrderTableProfileByPk($order_table_profile_id: uuid!) {
        delete_order_table_profiles_by_pk(order_table_profile_id: $order_table_profile_id) {
            order_table_profile_id
        }
    }
`;
